import * as Sentry from '@sentry/react'
const release = import.meta.env.__SENTRY_DEPLOY_RELEASE__ || 'undefined release'
const environment = import.meta.env.VITE_SENTRY_ENV || 'undefined environment'

const sentryInstance = Sentry.init({
    release,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    environment,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
})

export default sentryInstance
